//default from angular libraries
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule }   from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from  '@angular/common/http';
import { ScriptLoaderModule } from 'ngx-script-loader';
import { NgxPermissionsModule } from 'ngx-permissions';
import { DataTablesModule } from "angular-datatables";
import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';
import { CKEditorModule } from 'ckeditor4-angular';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgApexchartsModule } from "ng-apexcharts";
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { DatePipe, registerLocaleData } from '@angular/common'

//app routing module
import { AppRoutingModule } from './app-routing.module';

//multiselectdrop
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

//layout components
import { UserHeaderComponent } from './components/layout/user-header/user-header.component';
import { UserSidebarComponent } from './components/layout/user-sidebar/user-sidebar.component';
import { SuperUserSidebarComponent } from './components/layout/super-user-sidebar/super-user-sidebar.component';

import { UserFooterComponent } from './components/layout/user-footer/user-footer.component';
import { UserLayoutComponent } from './components/layout/user-layout/user-layout.component';

//general components
import { LoaderComponent } from './components/general/loader/loader.component';
import { ImagePreviewComponent } from './components/general/image-preview/image-preview.component';

//component
import { AppComponent } from './app.component';
import { LoginComponent } from './components/user/login/login.component';
import { DashboardComponent } from './components/user/dashboard/dashboard.component';
import { SuperAdminDashboardComponent } from './components/super_admin/super_admin_dashboard/super_admin_dashboard.component';
import { SuperAdminLangListComponent } from './components/super_admin/super_admin_lang_list/super_admin_lang_list.component';
import { SuperAdminLangDetailsComponent } from './components/super_admin/super_admin_lang_details/super_admin_lang_details.component';
import { SuperAdminMailConfigComponent } from './components/super_admin/super_admin_mail_config/super_admin_mail_config.component';
import { CreatePackageComponent } from './components/super_admin/package/package-create/package-create.component';
import { ProfileComponent } from './components/user/profile/profile.component';
import { ConfirmationComponent } from './components/general/modals/confirmation/confirmation.component';
import { ConfirmationComponent1 } from './components/general/modals/confirmation_notify/confirmation_notify.component';

import { SettingsComponent } from './components/user/settings/settings.component';
import { SubSettingsComponent } from './components/user/settings/sub-settings/sub-settings.component';
import { SubFormComponent } from './components/user/settings/sub-form/sub-form.component';
import { SupportTicketListComponent } from './components/user/ticket/support-ticket-list/support-ticket-list.component';
import { SupportTicketCreateComponent } from './components/user/ticket/support-ticket-create/support-ticket-create.component';
import { SupportTicketViewComponent } from './components/user/ticket/support-ticket-view/support-ticket-view.component';
import { DeadlineListComponent } from './components/user/deadline/deadline-list/deadline-list.component';
import { DeadlineCreateComponent } from './components/user/deadline/deadline-create/deadline-create.component';
import { DeadlineViewComponent } from './components/user/deadline/deadline-view/deadline-view.component';
import { DeadlineCalendarComponent } from './components/user/deadline/deadline-calendar/deadline-calendar.component';
import { DeadlineGeneralComponent } from './components/user/deadline/deadline-view/deadline-general/deadline-general.component';
import { DeadlineViewDeadComponent } from './components/user/deadline/deadline-view/deadline-viewdead/deadline-viewdead.component';
import { DeadlineOccurrenceComponent } from './components/user/deadline/deadline-view/deadline-occurrence/deadline-occurrence.component';
import { DeadlineActionComponent } from './components/user/deadline/deadline-view/deadline-action/deadline-action.component';


import { DocumentViewMangComponent } from './components/user/document_management/document_mang_view/document-viewmang/document-viewmang.component';
import { DocumentRepetitionComponent } from './components/user/document_management/document_mang_view/document-repetition/document-repetition.component';


import { ServicingListComponent } from './components/user/servicing/servicing-list/servicing-list.component';
import { ServicingCreateComponent } from './components/user/servicing/servicing-create/servicing-create.component';
import { ServicingMaintenance } from './components/user/servicing/servicing-maintenance/servicing-maintenance.component';
import { ServicingCalendarComponent } from './components/user/servicing/servicing-calendar/servicing-calendar.component';
import { ServicingViewComponent } from './components/user/servicing/servicing-list/servicing-view/servicing-view.component';
import { ServicingExtraOrdinaryComponent } from './components/user/servicing/servicing-list/servicing-extraordinary/servicing-extraordinary.component';
import { ServicingOrdinaryComponent } from './components/user/servicing/servicing-list/servicing-ordinary/servicing-ordinary.component';
import { ServicingViewserviceComponent } from './components/user/servicing/servicing-list/servicing-viewservice/servicing-viewservice.component';
import { ServicingMaintenancePlansComponent } from './components/user/servicing/servicing-maintenance_plans/servicing-maintenance_plans.component';
import { ServicingCreateMaintenanceComponent } from './components/user/servicing/servicing-maintenance_plans/servicing-createmaintenance/servicing-createmaintenance.component';
import { ServicingDocumentsComponent } from './components/user/servicing/servicing-list/servicing-documents/servicing-documents.component';
import { NotificationListComponent } from './components/user/human_resources/notification-list/notification-list.component';
import { NotificationCreateComponent } from './components/user/human_resources/notification-create/notification_create.component';
import { NotificationViewComponent } from './components/user/human_resources/notification-list/notification_view/notification-view.component';
import { NotificationMailComponent } from './components/user/human_resources/notification-list/notification_view/notification-mail/notification_mail.component';
import { MedicalExaminationComponent } from './components/user/human_resources/medical_examination/medical_examination.component';
import { MedicalExaminationCreateComponent } from './components/user/human_resources/medical_examination_create/medical_examination_create.component';
import { MedicalNewInterventionComponent } from './components/user/human_resources/medical_examination/medical-new-intervention/medical-new-intervention.component';

import { MedicalExaminationGeneralComponent } from './components/user/human_resources/medical_examination/medical-examination-general-modal/medical-examination-general-modal.component';
import { MedicalOccurrenceComponent } from './components/user/human_resources/medical_examination/medical-occurrence-modal/medical-occurrence-modal.component';
import { MedicalExaminationSendMailComponent } from './components/user/human_resources/medical_examination/medical-eaxmination-send-mail/medical-eaxmination-send-mail.component';


import { MedicalExaminationEditComponent } from './components/user/human_resources/medical_examination_edit/medical_examination_edit.component';
import { MedicalExaminationViewComponent } from './components/user/human_resources/medical_examination/medical-examination-view/medical_examination_view.component'
import { EmployeeListComponent } from './components/user/human_resources/employee-list/employee-list.component';
import { SkillsListComponent } from './components/user/human_resources/skills-list/skills-list.component';
import { EmployeeCreateComponent } from './components/user/human_resources/employee-create/employee-create.component';
import { EmployeeViewComponent } from './components/user/human_resources/employee-list/employee-view/employee-view.component';
import { EmployeeViewemployeeComponent } from './components/user/human_resources/employee-list/employee-viewemployee/employee-viewemployee.component';
import { CreateDeliveryReportComponent } from './components/user/human_resources/employee-list/employee-createdelivery/employee-createdelivery.component';
import { CreateAddProtectiveComponent } from './components/user/human_resources/employee-list/employee-createaddprotective/employee-createaddprotective.component';
import { CreateAddThirdProtectiveComponent } from './components/user/human_resources/employee-list/employee-createaddthirdprotective/employee-createaddthirdprotective.component';

import { SendMailDpiComponent } from './components/user/human_resources/employee-list/employee_dpiemail/employee-dpiemail.component';


import { SkillsCreateComponent } from './components/user/human_resources/skills-create/skills-create.component';
import { SkillsAnalysisComponent } from './components/user/human_resources/skills_analysis-create/skills_analysis-create.component';
import { SkillsDepartmentCreateComponent } from './components/user/human_resources/skills-department-create/skills-department-create.component';
import { CreateCourseComponent } from './components/user/human_resources/employee-list/course-create/course_create.component';
import { MeasurementComponent } from './components/user/measurement/measurement.component';
import { CreateMeasurementComponent } from './components/user/measurement/measurement-create/measurement-create.component';
import { MeasurementMaintenance } from './components/user/measurement/calibration_planning/calibration_planning.component';
import { MeasurementViewComponent } from './components/user/measurement/measurement-list/measurement-view/measurement-view.component';
import { CalibrationPlansComponent } from './components/user/measurement/measurement-calibration_plans/measurement-calibration_plans.component';
import { MeasurementCreateCalibrationComponent } from './components/user/measurement/measurement-calibration_plans/measurement-createcalibration/measurement-createcalibration.component';

import { MeasurementExtraOrdinaryComponent } from './components/user/measurement/measurement-list/measurement-extraordinary/measurement-extraordinary.component';


import { ProblemSolvingListComponent } from './components/user/problem_solving/problem_solving_list/problem-solving.component';

import { ProblemSolvingViewComponent } from './components/user/problem_solving/problem_solving_list/problem-solving-view/problem-solving-view.component';

import { ProblemSolvingCreateComponent } from './components/user/problem_solving/problem_solving_create/problem-solving-create.component';

import { ViewProblemSolvingComponent } from './components/user/problem_solving/problem_solving_list/problem-viewsolving/problem-viewsolving.component';

import { SendStakeHoldersComponent } from './components/user/problem_solving/problem_solving_list/sendstake_action/sendstake-action.component';


import { DocumentMangListComponent } from './components/user/document_management/document_mang/document-mang.component';
import { DocumentCreateComponent } from './components/user/document_management/document_mang_create/document-mang-create.component';
import { DocumentMangViewComponent } from './components/user/document_management/document_mang_view/document_mang-view.component';
import { DocumentMangActionComponent } from './components/user/document_management/document_mang_view/document_mang_action/document_mang_action.component';
import { DocumentGeneralComponent } from './components/user/document_management/document_mang_view/document-general/document-general.component';


import { CustomersListComponent } from './components/user/customers/customers_list/customers_list.component';
import { CreateCustomerComponent } from './components/user/customers/customer-create/customer_create.component';
import { CustomersViewComponent } from './components/user/customers/customers_list/customers-view/customers-view.component';
import { CustomersOperatingComponent } from './components/user/customers/customers_list/customers-operating/customers-operating.component';
import { CustomersEmployeeComponent } from './components/user/customers/customers_list/customers-employee/customers-employee.component';

import { ConsultancyListComponent } from './components/user/consultancy/consultancy_list/consultancy_list.component';

import { CreateConsultancyComponent } from './components/user/consultancy/consultancy-create/consultancy_create.component';

import { ConsultancyViewComponent } from './components/user/consultancy/consultancy_list/consultancy-view/consultancy-view.component';

import { ConsultancyCalendarComponent } from './components/user/consultancy/consultancy_list/consultancy-calendar/consultancy-calendar.component';
import { ComsultancyInterventionComponent } from './components/user/consultancy/consultancy_list/consultancy-intervention/consultancy-intervention.component';
import { ComsultancyTaskComponent } from './components/user/consultancy/consultancy_list/consultancy-task/consultancy-task.component';
import { ComsultancyDocumentComponent } from './components/user/consultancy/consultancy_list/consultancy-document/consultancy-document.component';
import { ComsultancyProtocolComponent } from './components/user/consultancy/consultancy_list/consultancy-protocol/consultancy-protocol.component';
import { ComsultancyViewProtocolComponent } from './components/user/consultancy/consultancy_list/view-protocol/view-protocol.component';

import { ReportingListComponent } from './components/user/consultancy/consultancy_reporting/consultancy-reporting.component';
import { ScheduledCoursesListComponent } from './components/user/academy/scheduled_courses_list/scheduled_courses_list.component';
import { CreateScheduleCourseComponent } from './components/user/academy/scheduled_courses-create/scheduled_courses_create.component';
import { ScheduledCoursesViewComponent } from './components/user/academy/scheduled_courses_list/scheduled-courses-view/scheduled-courses-view.component';
import { LanguageCertificateComponent } from './components/user/academy/scheduled_courses_list/scheduled-courses-view/language_certificate/langugage_certificate.component';


import { ChildComponent } from './components/user/academy/scheduled_courses_list/child.component';
import { AdminSupportTicketListComponent } from './components/user/admin_ticket/admin-support-ticket-list/admin-support-ticket-list.component';
import { AdminSupportTicketCreateComponent } from './components/user/admin_ticket/admin-support-ticket-create/admin-support-ticket-create.component';

import { AdminSupportTicketViewComponent } from './components/user/admin_ticket/admin-support-ticket-view/admin-support-ticket-view.component';
import { MailConfigComponent } from './components/user/mail_config/mail_config.component';
import { CourseCatelogListComponent } from './components/user/academy/course_catelog/course_catelog.component';
import { CoursesCreateComponent } from './components/user/academy/courses-create/courses-create.component';
import { CourseCatalogViewComponent } from './components/user/academy/course_catelog/course-catalog-view/course-catalog-view.component';
import { ModulesCreateComponent } from './components/user/academy/course_catelog/modules-create/modules-create.component';
import { FinaltestSetupComponent } from './components/user/academy/course_catelog/finaltest-setup/finaltest-setup.component';
import { QualifiedTeacherListComponent } from './components/user/academy/qualified_teacher/qualified_teacher.component';

import { TeacherCreateComponent } from './components/user/academy/qualified-teacher-create/qualified_teacher_create.component';
import { QSkillsCreateComponent } from './components/user/academy/skills-create/skills_create.component';
import { QualifiedTeacherViewComponent } from './components/user/academy/qualified_teacher/qualified-teacher-view/qualified-teacher-view.component';
import { ProjectListComponent } from './components/user/project/project_list/project.component';
import { ProjectViewComponent } from './components/user/project/project_view/project_view.component';
import { ProtocolCreateComponent } from './components/user/project/project_view/protocol_create/protocol_create.component';
import { ProtocolViewComponent } from './components/user/project/project_view/protocol_view/protocol_view.component';
import { ProjectClassComponent } from './components/user/project/project_class/project_class.component';
import { ProjectReportingListComponent } from './components/user/project/project_reporting/project-reporting.component';
import { AuditListComponent } from './components/user/audit/audit_list/audit_list.component';
import { AddprojectclassComponent } from './components/user/project/projectclass_create/projectclass_create.component';

import { AuditViewComponent } from './components/user/audit/audit_list/audit-view/audit-view.component';
import { AuditCreateComponent } from './components/user/audit/audit-create/audit_create.component';
import { AuditStandardListComponent } from './components/user/audit/audit_standard/audit_standard.component';
import { StandardCreateComponent } from './components/user/audit/standard_create/standard_create.component';
import { ChapterCreateComponent } from './components/user/audit/chapter_create/chapter_create.component';
import { DocumentInformationCreateComponent } from './components/user/audit/document_information_create/document_information_create.component';
import { InstallationListComponent } from './components/super_admin/installation_list/installation-list/installation-list.component';
import { CreateInstallationComponent } from './components/super_admin/installation_list/installation-create/installation_create.component';

import { AdminDashboardComponent } from './components/user/admin_dashboard/admin_dashboard.component';
import { SuperAdminLoginComponent } from './components/super_admin/super_admin_login/super_admin_login.component';
import { SuperAdminUserDetailsComponent } from './components/super_admin/super_admin_user_details/super_admin_user_details.component';
import { PackageListComponent } from './components/super_admin/package/package-list/package-list.component';
import { ComsultancyViewDocumentComponent } from './components/user/consultancy/consultancy_list/view-document/view-document.component';
import { ConsultancyViewTaskComponent } from './components/user/consultancy/consultancy_list/view-task/view-task.component';
import { ConsultancyCloseTaskComponent } from './components/user/consultancy/consultancy_list/close-task/close-task.component';
import { ConsultancyLangTaskComponent } from './components/user/consultancy/consultancy_list/language-task/language-task.component';
import { ComsultancyViewInterventionComponent } from './components/user/consultancy/consultancy_list/view-intervention/view-intervention.component';


import { SupplyersListComponent } from './components/user/customers/supplyers/supplyers_list.component';
import { CreateSupplyerComponent } from './components/user/customers/supplyer-create/supplyer_create.component';
import { SupplyersViewComponent } from './components/user/customers/supplyers/supplyers-view/supplyers-view.component';
import { SupplyersOperatingComponent } from './components/user/customers/supplyers/supplyers-operating/supplyers-operating.component';

import { DashboardCalendarComponent } from './components/user/dashboard/dashboard-calendar/dashboard-calendar.component';
import { PackageDetailsComponent } from './components/super_admin/package/package-details/package-details.component';

//common services
import { AuthGuard } from "./common/auth-guard";
import { HttpConfigInterceptor } from './common/httpconfig-interceptor';

//service
import { GeneralService } from './services/general.service';
import { AuthService } from './services/auth.service';
import { ProfileService } from './services/profile.service';
import { SettingsService } from './services/settings.service';
import { TicketService } from './services/ticket.service';
import { AdminTicketService } from './services/adminticket.service';
import { DeadlineService } from './services/deadline.service';
import { ServicingService } from './services/servicing.service';
import { NotificationService } from './services/notification.service';
import { MedicalService } from './services/medical.service';
import { ConfirmationDialogService } from './components/general/modals/confirmation/confirmation.service';
import { ConfirmationDialogService1 } from './components/general/modals/confirmation_notify/confirmation_notify.service';
import { EmployeeService } from './services/employee.service';
import { MeasurementService } from './services/measurement.service';
import { ProblemSolvingService } from './services/problem_solving.service';
import { DocumentMangService } from './services/document_mang.service';
import { CustomersService } from './services/customers.service';
import { ConsultancyService } from './services/consultancy.service';
import { ScheduledCoursesService } from './services/scheduled_courses.service';
import { CategoryCatelogService } from './services/category_catelog.service';
import { QualifiedTeacherService } from './services/qualified_teacher.service';
import { ProjectService } from './services/project.service';
import { AuditService } from './services/audit.service';
import { InstallationService } from './services/installation.service';
import { GanttModule } from '@syncfusion/ej2-angular-gantt';
import { SupplyersService } from './services/supplyers.service';
import { SuperAdminService } from './services/superadmin.service';

import { SuperadminAuthService } from './services/superadminauth.service';
import { UserLayoutService } from './services/UserLayout.service';

import { TreatmentRegisterComponent } from './components/user/privacy/treatment-register/treatment-register-list/treatment-register.component';
import { TreatmentRegisterCreateComponent } from './components/user/privacy/treatment-register/treatment-register-create/treatment-register-create.component';
import { AppointmentDataProcessorComponent } from './components/user/privacy/appointment-data-processor/appointment-data-processor.component';
import { InformativeComponent } from './components/user/privacy/informative/informative.component';
import { PrivacyService } from './services/privacy.service';
import { SkillsCourseViewComponent } from 'src/app/components/user/human_resources/skills-course-view/skills-course-view.component'

//directives
import { FileDesignDirective } from './directives/filedesign/file-design.directive';

//pipes
import { TimeConveterPipe } from './pipes/time-converter.pipe';
import { nl2brPipe } from './pipes/nl2br.pipe';
import { stringbreakPipe } from './pipes/stringbreak.pipe';

//accordion
import { AccordionModule } from 'ngx-bootstrap/accordion';

//drag-drop
import { DragulaModule } from 'ng2-dragula';

//radar
import { ChartsModule } from 'ng2-charts';

import {MatTreeModule} from '@angular/material/tree';
import {MatIconModule} from '@angular/material';
import { MatTableModule } from '@angular/material/table';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatInputModule} from '@angular/material/input';

import { FusionChartsModule } from "angular-fusioncharts";

// Load FusionCharts
import FusionCharts from "fusioncharts/core";
// Load Charts module
import Column2d from "fusioncharts/viz/column2d";
import StackedColumn2d from "fusioncharts/viz/stackedcolumn2d";

// Load fusion theme
import FusionTheme from "fusioncharts/themes/es/fusioncharts.theme.fusion";
import { SafeHtmlPipe } from "src/app/pipes/safe-html pipe"
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
// Add dependencies to FusionChartsModule
import { CreateConsultancyEventComponent } from './components/user/consultancy/consultancy-event-create/consultancy-event-create.component';
FusionChartsModule.fcRoot(
  FusionCharts,
  Column2d,
  StackedColumn2d,
  FusionTheme
);
import { CommonUtility } from './utility/commonUtility';
import localeIt from '@angular/common/locales/it';
import localeEn from '@angular/common/locales/en';
import { CalendarComponent } from  'src/app/components/user/calendar/calendar.component';
import { CalendarAddEditEventComponent } from 'src/app/components/user/calendar/calendar-add-edit-event/calendar-add-edit-event.component'
import { DashboardService } from 'src/app/services/dashboard.service'
import { ProjectCreateEditComponent } from 'src/app/components/user/project/project_create_edit/project_create_edit.component'
registerLocaleData(localeIt);
registerLocaleData(localeEn);
@NgModule({
  declarations: [
    AppComponent,
    UserLayoutComponent,
    UserHeaderComponent,
    UserSidebarComponent,
    SuperUserSidebarComponent,
    UserFooterComponent,
    LoaderComponent,
    ImagePreviewComponent,
    LoginComponent,
    DashboardComponent,
    SuperAdminDashboardComponent,
    SuperAdminLangListComponent,
    SuperAdminLangDetailsComponent,
    SuperAdminMailConfigComponent,
    CreatePackageComponent,
    ProfileComponent,
    ConfirmationComponent,
    SettingsComponent,
    SubSettingsComponent,
    SubFormComponent,
    SupportTicketListComponent,
    SupportTicketCreateComponent,
    SupportTicketViewComponent,
    DeadlineListComponent,
    DeadlineCreateComponent,
    DeadlineCalendarComponent,
    DeadlineViewComponent,
    DeadlineGeneralComponent,
    DeadlineViewDeadComponent,
    DeadlineOccurrenceComponent,
    DeadlineActionComponent,
    DocumentGeneralComponent,
    DocumentViewMangComponent,
    DocumentRepetitionComponent,
    TimeConveterPipe,
    nl2brPipe,
    stringbreakPipe,
    ServicingListComponent,
    ServicingCreateComponent,
    ServicingMaintenance,
    ServicingCalendarComponent,
    ServicingViewComponent,
    ServicingExtraOrdinaryComponent,
    ServicingOrdinaryComponent,
    ServicingViewserviceComponent,
    ServicingMaintenancePlansComponent,
    ServicingCreateMaintenanceComponent,
    ServicingDocumentsComponent,
    NotificationListComponent,
    NotificationCreateComponent,
    MedicalExaminationCreateComponent,
    MedicalNewInterventionComponent,
    MedicalExaminationEditComponent,
    MedicalExaminationGeneralComponent,
    MedicalOccurrenceComponent,
    MedicalExaminationSendMailComponent,
    MedicalExaminationViewComponent,
    NotificationViewComponent,
    NotificationMailComponent,
    MedicalExaminationComponent,
    EmployeeListComponent,
    SkillsListComponent,
    EmployeeCreateComponent,
    EmployeeViewComponent,
    EmployeeViewemployeeComponent,
    CreateDeliveryReportComponent,
    SendMailDpiComponent,
    CreateAddProtectiveComponent,
    CreateAddThirdProtectiveComponent,
    SkillsCreateComponent,
    SkillsAnalysisComponent,
    SkillsDepartmentCreateComponent,
    CreateCourseComponent,
    MeasurementComponent,
    CreateMeasurementComponent,
    MeasurementMaintenance,
    MeasurementViewComponent,
    CalibrationPlansComponent,
    MeasurementCreateCalibrationComponent,
    ProblemSolvingListComponent,
    ProblemSolvingViewComponent,
    ProblemSolvingCreateComponent,
    ViewProblemSolvingComponent,
    SendStakeHoldersComponent,
    DocumentMangListComponent,
    DocumentCreateComponent,
    DocumentMangViewComponent,
    DocumentMangActionComponent,
    CustomersListComponent,
    CreateCustomerComponent,
    CustomersViewComponent,
    CustomersOperatingComponent,
    CustomersEmployeeComponent,
    ConsultancyListComponent,
    CreateConsultancyComponent,
    ConsultancyViewComponent,
    ConsultancyCalendarComponent,
    ComsultancyInterventionComponent,
    ComsultancyTaskComponent,
    ComsultancyDocumentComponent,
    ComsultancyProtocolComponent,
    ComsultancyViewProtocolComponent,
    ReportingListComponent,
    FileDesignDirective,
    ScheduledCoursesListComponent,
    CreateScheduleCourseComponent,
    ScheduledCoursesViewComponent,
    ChildComponent,
    LanguageCertificateComponent,
    AdminSupportTicketListComponent,
    AdminSupportTicketCreateComponent,
    AdminSupportTicketViewComponent,
    MailConfigComponent,
    CourseCatelogListComponent,
    CoursesCreateComponent,
    CourseCatalogViewComponent,
    ModulesCreateComponent,
    FinaltestSetupComponent,
    QualifiedTeacherListComponent,
    TeacherCreateComponent,
    QSkillsCreateComponent,
    QualifiedTeacherViewComponent,
    ProjectListComponent,
    ProjectViewComponent,
    ProtocolCreateComponent,
    ProtocolViewComponent,
    ProjectClassComponent,
    ProjectReportingListComponent,
    AuditListComponent,
    AddprojectclassComponent,
    AuditViewComponent,
    AuditCreateComponent,
    AuditStandardListComponent,
    StandardCreateComponent,
    ChapterCreateComponent,
    DocumentInformationCreateComponent,
    ConfirmationComponent1,
    InstallationListComponent,
    CreateInstallationComponent,
    AdminDashboardComponent,
    SuperAdminLoginComponent,
    SuperAdminUserDetailsComponent,
    PackageListComponent,
    ComsultancyViewDocumentComponent,
    ConsultancyViewTaskComponent,
    ConsultancyCloseTaskComponent,
    ConsultancyLangTaskComponent,
    ComsultancyViewInterventionComponent,
    MeasurementExtraOrdinaryComponent,
    SupplyersListComponent,
    CreateSupplyerComponent,
    SupplyersViewComponent,
    SupplyersOperatingComponent,
    DashboardCalendarComponent,
    SafeHtmlPipe,
    PackageDetailsComponent,
    CreateConsultancyEventComponent,
    CalendarAddEditEventComponent,
    TreatmentRegisterComponent,
    TreatmentRegisterCreateComponent,
    AppointmentDataProcessorComponent,
    SkillsCourseViewComponent,
    InformativeComponent,
    CalendarComponent,
    ProjectCreateEditComponent
  ],
  imports: [
    BrowserModule,
    DataTablesModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ScriptLoaderModule,                                                   
    ModalModule.forRoot(),
    CKEditorModule,
    PdfViewerModule,
    NgxPermissionsModule.forRoot(),                                                                        
    BrowserAnimationsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    NgxDocViewerModule,
    // NgDatepickerModule,
    NgMultiSelectDropDownModule.forRoot(),
    AccordionModule.forRoot(),
    DragulaModule.forRoot(),
    NgApexchartsModule,
    ChartsModule,
    GanttModule,
    MatTreeModule,
    MatIconModule,
    MatTableModule,
    MatDatepickerModule,  
    MatNativeDateModule,
    MatInputModule,
    NgxMaterialTimepickerModule,
    FusionChartsModule,
    MatSlideToggleModule,
  ],
  exports: [ AppComponent],
  providers: [
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
    GeneralService,
    AuthService,
    ProfileService,
    SettingsService,
    TicketService,
    DeadlineService,
    ServicingService,
    NotificationService,
    MedicalService,
    ConfirmationDialogService,
    ConfirmationDialogService1,
    EmployeeService,
    MeasurementService,
    ProblemSolvingService,
    DocumentMangService,
    CustomersService,
    ConsultancyService,
    ScheduledCoursesService,
    AdminTicketService,
    CategoryCatelogService,
    QualifiedTeacherService,
    ProjectService,
    AuditService,
    InstallationService,
    SuperadminAuthService,
    SuperAdminService,
    DatePipe,
    SupplyersService,
    BsModalRef,
    UserLayoutService,
    CommonUtility,
    PrivacyService,
    DashboardService
  ],
  entryComponents: [ ConfirmationComponent,ConfirmationComponent1, DeadlineCreateComponent, DeadlineGeneralComponent, DeadlineViewDeadComponent, DeadlineOccurrenceComponent, DeadlineActionComponent, ServicingCreateComponent, ServicingMaintenance, ServicingExtraOrdinaryComponent, ServicingOrdinaryComponent,ServicingViewserviceComponent, ServicingMaintenancePlansComponent,ServicingCreateMaintenanceComponent,ServicingDocumentsComponent,NotificationListComponent,NotificationCreateComponent,NotificationMailComponent,MedicalExaminationComponent,MedicalExaminationCreateComponent,MedicalNewInterventionComponent,MedicalExaminationEditComponent,MedicalExaminationViewComponent,EmployeeListComponent,EmployeeCreateComponent,EmployeeViewComponent,EmployeeViewemployeeComponent,CreateDeliveryReportComponent,SendMailDpiComponent,CreateAddProtectiveComponent,CreateAddThirdProtectiveComponent,SkillsCreateComponent,SkillsAnalysisComponent,SkillsDepartmentCreateComponent,CreateCourseComponent,MeasurementComponent,CreateMeasurementComponent,MeasurementMaintenance,CalibrationPlansComponent,MeasurementCreateCalibrationComponent,ProblemSolvingCreateComponent,SendStakeHoldersComponent,DocumentCreateComponent,DocumentMangActionComponent,DocumentViewMangComponent,CreateCustomerComponent,DocumentGeneralComponent,DocumentRepetitionComponent,CustomersOperatingComponent, CustomersEmployeeComponent,CreateConsultancyComponent,ComsultancyInterventionComponent,ComsultancyTaskComponent,ViewProblemSolvingComponent,ComsultancyDocumentComponent,ComsultancyProtocolComponent,ComsultancyViewProtocolComponent,CreateScheduleCourseComponent,ChildComponent,LanguageCertificateComponent,CoursesCreateComponent,ModulesCreateComponent,FinaltestSetupComponent,TeacherCreateComponent,QSkillsCreateComponent,ProtocolCreateComponent,ProtocolViewComponent,AddprojectclassComponent,AuditViewComponent,AuditCreateComponent,StandardCreateComponent,ChapterCreateComponent,CreateConsultancyEventComponent,DocumentInformationCreateComponent,CreateInstallationComponent,CreatePackageComponent,ComsultancyViewDocumentComponent, ConsultancyViewTaskComponent,ConsultancyCloseTaskComponent,ConsultancyLangTaskComponent,ComsultancyViewInterventionComponent,SkillsListComponent,MeasurementExtraOrdinaryComponent,CreateSupplyerComponent,SupplyersOperatingComponent,MedicalExaminationGeneralComponent,MedicalOccurrenceComponent,MedicalExaminationSendMailComponent,TreatmentRegisterCreateComponent,AppointmentDataProcessorComponent,SkillsCourseViewComponent,InformativeComponent, CalendarComponent,CalendarAddEditEventComponent,ProjectCreateEditComponent ],
  bootstrap: [AppComponent]                                                                                                                                                                                                                                                                                                                                 
})
export class AppModule { }
